export enum PresetSettingActionTypes {
  SetIsPresetSettingDisplayed = 'PRESET_SETTING/SET_IS_PRESET_SETTING',
}
